var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVega(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.87 151.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        mask: url(#mask);\n      }\n\n      .cls-6 {\n        fill: none;\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-8 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-11 {\n        isolation: isolate;\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-15 {\n        fill: #f5dddd;\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-17 {\n        mix-blend-mode: multiply;\n        opacity: .2;\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 20.49,
    width: 100.89,
    height: 149.56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 20.49,
    width: 100.89,
    height: 149.56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 20.49,
    y: 0,
    width: 100.89,
    height: 133.14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -164.81,
    y1: -313.06,
    x2: -164.65,
    y2: -313.06,
    gradientTransform: "translate(-261961.47 -137816.18) rotate(-90) scale(837 -837)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5dddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5dddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#fae9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#fef0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff2f2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 20.49,
    width: 100.89,
    height: 149.56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 20.49,
    y: 133.14,
    width: 100.89,
    height: 16.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 20.49,
    y: 133.14,
    width: 100.89,
    height: 16.41
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -158.83,
    y1: -312.36,
    x2: -158.67,
    y2: -312.36,
    gradientTransform: "translate(-32159.37 16521.71) rotate(90) scale(103.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 20.49,
    y: 133.14,
    width: 100.89,
    height: 16.41,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 20.49,
    y: 133.14,
    width: 100.89,
    height: 16.41
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -158.83,
    y1: -312.36,
    x2: -158.67,
    y2: -312.36,
    gradientTransform: "translate(-32159.37 16521.71) rotate(90) scale(103.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#313541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#424651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#74767e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#9ea0a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#c1c2c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#dcdddf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#eff0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 38.62,
    y: 48.32,
    width: 64.63,
    height: 64.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M48.09,57.79c12.62-12.62,33.08-12.62,45.7,0,12.62,12.62,12.62,33.08,0,45.7-12.62,12.62-33.08,12.62-45.7,0-12.62-12.62-12.62-33.08,0-45.7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -161.56,
    cy: -316.32,
    fx: -161.56,
    fy: -316.32,
    r: 0.16,
    gradientTransform: "translate(64326.58 32899.53) rotate(90) scale(203.13 -203.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M44.13,80.64c0,14.8,12,26.8,26.8,26.8s26.8-12,26.8-26.8-12-26.8-26.8-26.8-26.8,12-26.8,26.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -166.19,
    y1: -312.92,
    x2: -166.03,
    y2: -312.92,
    gradientTransform: "translate(-105378.06 -55897.07) rotate(-90) scale(336.99 -336.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#df1995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ee3daf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fa5bc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "img_vega_front"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 20.49,
    y: 0,
    width: 100.89,
    height: 133.14
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 20.49,
    y: 133.14,
    width: 100.89,
    height: 16.41
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 20.78,
    y: 30.48,
    width: 100.32,
    height: 100.32,
    transform: "translate(-36.24 73.78) rotate(-45)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M63.25,16.96c.77,0,1.35.55,1.35,1.26s-.58,1.27-1.35,1.27h-1v1.38h-.75v-3.91h1.75ZM62.25,17.65v1.14h1c.32,0,.57-.25.57-.57s-.25-.57-.57-.57h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M66.2,17.88c.34,0,.64.12.88.32v-.23h.69v2.9h-.69v-.23c-.24.2-.54.32-.88.32-.8,0-1.41-.66-1.41-1.53s.61-1.53,1.41-1.53M65.5,19.41c0,.47.35.84.78.84s.78-.36.78-.84-.34-.84-.78-.84-.78.36-.78.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M68.25,19.41c0-.88.66-1.53,1.53-1.53.67,0,1.21.39,1.43.96l-.7.21c-.13-.28-.4-.47-.74-.47-.46,0-.81.36-.81.84s.36.84.81.84c.33,0,.61-.18.74-.47l.7.21c-.22.57-.76.96-1.43.96-.88,0-1.53-.66-1.53-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M71.68,16.96h1.89c.69,0,1.21.46,1.21,1.07,0,.32-.14.6-.38.79.33.2.55.54.55.94,0,.64-.55,1.12-1.26,1.12h-2v-3.91ZM72.43,17.65v.86h1.14c.25,0,.43-.18.43-.44s-.18-.43-.43-.43h-1.14ZM72.43,19.2v.97h1.26c.27,0,.48-.21.48-.49s-.21-.49-.48-.49h-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M75.8,16.82c.26,0,.45.19.45.44s-.19.45-.45.45-.44-.19-.44-.45.19-.44.44-.44M75.46,17.96h.7v2.9h-.7v-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M80.37,19.1c0,1.02-.83,1.85-1.85,1.85s-1.85-.83-1.85-1.85.83-1.85,1.85-1.85,1.85.83,1.85,1.85"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 44.13,
    y: 53.83,
    width: 53.61,
    height: 53.61
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVega);
export default __webpack_public_path__ + "static/media/VEGA.54eafcbbf8ecfc7621f037e57ac25af0.svg";
export { ForwardRef as ReactComponent };